// NextJS implementation: https://github.com/vercel/next.js/blob/canary/packages/next/client/request-idle-callback.ts
const root = typeof window !== 'undefined' ? window : {};
const nativeRequestIdleCallback = root.requestIdleCallback;

export const requestIdleCallback = nativeRequestIdleCallback
    ? nativeRequestIdleCallback.bind(root)
    : function requestIdleCallbackFallback(cb) {
        const start = Date.now();
        return setTimeout(() => {
            cb({
                didTimeout: false,
                timeRemaining: () => {
                    return Math.max(0, 50 - (Date.now() - start));
                },
            });
        }, 1);
    };
